import React, { useState } from "react";
import { saveAs } from "file-saver";

const getRandomString = (length, chars) => {
  let result = "";
  const characters = chars;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const getRandomNumber = (min, max, decimalPlaces = 0) => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor((Math.random() * (max - min) + min) * factor) / factor;
};

const generateCSVData = (
  iSOLines,
  p463LLines,
  c463LLines,
  NFEVLines,
  French80LargeLines,
  French80MediumLines,
  French80SmallLines,
  French100LargeLines,
  French100MediumLines,
  French100SmallLines,

) => {
  const headers = [
    "NSN",
    "NIIN",
    "Nomenclature",
    "Weight",
    "Length",
    "Width",
    "Height",
    "Authorized Qty",
    "On-Hand Qty",
    "Storage Type",
    "MaxSupportedWeight",
  ];

  let rows = [headers.join(",")];
  rows.join("\n");

  for (let i = 0; i < iSOLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 300, 2);
    const length = getRandomNumber(5, 40, 1);
    const width = getRandomNumber(5, 40, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "ISU-90";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < p463LLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 300, 2);
    const length = getRandomNumber(5, 40, 1);
    const width = getRandomNumber(5, 40, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "436L";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < c463LLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 300, 2);
    const length = getRandomNumber(5, 40, 1);
    const width = getRandomNumber(5, 40, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "C463L";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < NFEVLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 300, 2);
    const length = getRandomNumber(5, 40, 1);
    const width = getRandomNumber(5, 40, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "NFEV";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French80LargeLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(20, 60, 2);
    const length = getRandomNumber(30, 60, 1);
    const width = getRandomNumber(30, 60, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "80x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French80MediumLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 40, 2);
    const length = getRandomNumber(15, 40, 1);
    const width = getRandomNumber(15, 40, 1);
    const height = getRandomNumber(5, 30, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "80x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French80SmallLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(0.128, 10, 2);
    const length = getRandomNumber(1, 20, 1);
    const width = getRandomNumber(1, 20, 1);
    const height = getRandomNumber(1, 20, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "80x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French100LargeLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(20, 60, 2);
    const length = getRandomNumber(30, 60, 1);
    const width = getRandomNumber(30, 60, 1);
    const height = getRandomNumber(5, 40, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "100x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French100MediumLines; i++) {
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(10, 40, 2);
    const length = getRandomNumber(15, 40, 1);
    const width = getRandomNumber(15, 40, 1);
    const height = getRandomNumber(5, 30, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "100x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  for (let i = 0; i < French100SmallLines; i++) {

    console.log("Small");
    const nsn = getRandomString(
      getRandomNumber(9, 15),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    );
    const niin = getRandomString(getRandomNumber(7, 10), "0123456789");
    const nomenclature = getRandomString(
      getRandomNumber(5, 25),
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ "
    );
    const weight = getRandomNumber(0.128, 10, 2);
    const length = getRandomNumber(1, 20, 1);
    const width = getRandomNumber(1, 20, 1);
    const height = getRandomNumber(1, 20, 1);
    const authorizedQty = getRandomNumber(1, 20);
    const onHandQty = getRandomNumber(1, authorizedQty);
    const storageType = "100x120";
    const maxSupportedWeight = 5000;

    rows.push(
      `${nsn},${niin},${nomenclature},${weight},${length},${width},${height},${authorizedQty},${onHandQty},${storageType},${maxSupportedWeight}`
    );
    rows.join("\n");
  }
  return rows.join("\n");
};

const CSVGenerator = () => {
  const [iSOLines, setISOLines] = useState(0);
  const [p463LLines, set463LLines] = useState(0);
  const [c463LLines, setc463LLines] = useState(0);
  const [NFEVLines, setNFEVLines] = useState(0);
  const [French80LargeLines, setFrench80LargeLines] = useState(0);
  const [French80MediumLines, setFrench80MediumLines] = useState(0);
  const [French80SmallLines, setFrench80SmallLines] = useState(0);
  const [French100LargeLines, setFrench100LargeLines] = useState(0);
  const [French100MediumLines, setFrench100MediumLines] = useState(0);
  const [French100SmallLines, setFrench100SmallLines] = useState(0);
  const [documentName, setDocumentName]= useState("");

  const handleDownload = () => {
    const csvContent = generateCSVData(
      iSOLines,
      p463LLines,
      c463LLines,
      NFEVLines,
      French80LargeLines,
      French80MediumLines,
      French80SmallLines,
      French100LargeLines,
      French100MediumLines,
      French100SmallLines
    );
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const saveNamed = documentName +".csv";
    saveAs(blob, saveNamed);
  };

  return (
    <div className="csvgen">
      <h1 className="text-xl font-bold mb-4">CSV File Generator</h1>
      <label className="mb-2" style={{ display: "block" }}>
        Number of ISU-90 Lines:
        <input
          type="number"
          value={iSOLines}
          onChange={(e) => setISOLines(Number(e.target.value))}
          min="1"
          className="ml-2 border rounded p-1"
        />
      </label>
      <label className="mb-2" style={{ display: "block" }}>
        Number of 463L Lines:
        <input
          type="number"
          value={p463LLines}
          onChange={(e) => set463LLines(Number(e.target.value))}
          min="1"
          className="ml-2 border rounded p-1"
        />
      </label>
      <label className="mb-2" style={{ display: "block" }}>
        Number of C463L Lines:
        <input
          type="number"
          value={c463LLines}
          onChange={(e) => setc463LLines(Number(e.target.value))}
          min="1"
          className="ml-2 border rounded p-1"
        />
      </label>
      <label className="mb-2" style={{ display: "block" }}>
        Number of NFEV Lines:
        <input
          type="number"
          value={NFEVLines}
          onChange={(e) => setNFEVLines(Number(e.target.value))}
          min="1"
          className="ml-2 border rounded p-1"
        />
      </label>
      <div className="sameType">
        Number of 80x120 Lines:
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French80LargeLines}
            onChange={(e) => setFrench80LargeLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Large Boxes
        </label>
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French80MediumLines}
            onChange={(e) => setFrench80MediumLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Medium Boxes
        </label>
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French80SmallLines}
            onChange={(e) => setFrench80SmallLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Small Boxes
        </label>
      </div>
      <div className="sameType">
        Number of 100x120 Lines:
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French100LargeLines}
            onChange={(e) => setFrench100LargeLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Large Boxes
        </label>
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French100MediumLines}
            onChange={(e) => setFrench100MediumLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Medium Boxes
        </label>
        <label className="mb-2" style={{ display: "block" }}>
          <input
            type="number"
            value={French100SmallLines}
            onChange={(e) => setFrench100SmallLines(Number(e.target.value))}
            min="1"
            className="ml-2 border rounded p-1"
          />
          Small Boxes
        </label>
      </div>
      <input
        type="string"
        value={documentName}
        onChange={(e) => setDocumentName(e.target.value)}
        min="1"
        className="ml-2 border rounded p-1"
      />
      <button
        onClick={handleDownload}
        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 mt-2"
      >
        Download CSV
      </button>
    </div>
  );
};

export default CSVGenerator;
